// extracted by mini-css-extract-plugin
module.exports = {"vMenuNavMobileHeight":"60px","tablet-landscape-up":"(min-width: calc(1024 * 1px))","content":"Store_content__2VFEK","content_bottomGap":"Store_content_bottomGap__1S1T6"};